module.exports = __webpack_public_path__ + "img/2021-7.c0cf17fa.jpg";